import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import enAuth from '@/locales/en/auth.json'
// Import translation files
import enCommon from '@/locales/en/common.json'
import roAuth from '@/locales/ro/auth.json'
import roCommon from '@/locales/ro/common.json'

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
  },
  ro: {
    common: roCommon,
    auth: roAuth,
  },
}

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth'],

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
